export const EXCMNOTE_SHOW_RESET = 'EXCMNOTE_SHOW_RESET'
export const EXCMNOTE_SHOW_SET_ERROR = 'EXCMNOTE_SHOW_SET_ERROR'
export const EXCMNOTE_SHOW_SET_RETRIEVED = 'EXCMNOTE_SHOW_SET_RETRIEVED'
export const EXCMNOTE_SHOW_TOGGLE_LOADING = 'EXCMNOTE_SHOW_TOGGLE_LOADING'
